import React, { useEffect, useState } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";

const Contact = () => {
  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 5000);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  function sendEmail(e) {
    e.preventDefault();

    // NOTE: These are the previous owner's EmailJS credentials (service id,
    // template id, user id). Replace them with your own EmailJS account
    // details (https://www.emailjs.com/) so contact-form messages actually
    // reach your inbox instead of theirs.
    emailjs
      .sendForm(
        "gmail",
        "template_q47xkq4",
        e.target,
        "user_n88EK52R0Rnv7dMJfAWUO"
      )
      .then(
        (result) => {
          if (result) {
            alert("your message successfully sent!");
          }
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  return (
    <section id="contact">
      <div className=" container-fluid contact-container-top">
        <div className="scroll-text" >
          <p className=""
            style={{ transform: `translateX(${scroll}%)` }}
          >
            CONTACT
          </p>
        </div>
        <h2
          style={{
            color: "#00ffd5",
            textAlign: "center",
            marginTop: "-60px",
            marginBottom: "80px",
            fontSize: '36px',
            position: 'relative',
            zIndex: 2,
          }}
        >
          CONTACT ME
          <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
            <div className="main">
              <div className="ball"></div>
            </div>
          </div>
        </h2>
        {/* <h2 className="text-white text-center pb-5">
          <span
            style={{
              paddingBottom: "6px",
              fontSize: "1.2rem",
              letterSpacing: "2px",
              fontWeight: "bold",
              textTransform: "uppercase",
              color: "#00ffd5",
            }}
          >
            Get In Touch
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div className="main">
                <div className="ball"></div>
              </div>
            </div>
          </span>
        </h2> */}
        <div
          className="row pl-4"
          style={{ maxWidth: "1300px", margin: "auto" }}
        >
          <div className="col-md-8 col-sm-12 ">
            <form className="contact-form " action="" onSubmit={sendEmail}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your name "
                  id=""
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Your email address "
                  id=""
                  required
                />

                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  id=""
                  required
                />

                <textarea
                  type="text-area"
                  name="message"
                  placeholder=" Your message "
                  id=""
                  required
                  rows="4"
                  cols="38"
                  className="order-text-area  contact-text-area"
                  style={{ height: " 160px", paddingTop: "15px" }}
                />
              </div>

              <div className="submit-button-container">
                <div className="submit-button ">
                  <input
                    className=" "
                    type="submit"
                    value="Submit"
                    style={{
                      background: "transparent",
                      padding: " 0 0px 10px",
                      position: "absolute",
                      top: "-10px",
                      left: 0,
                      width: "100%",
                      height: "100%",
                      // marginTop: "-10px",
                      // border: "2px solid #00ffd5",
                      color: "#000",
                      fontWeight: "normal",
                      // letterSpacing: "2px",
                      textTransform: "uppercase",
                      // display: "none"
                    }}
                  />
                  {/* Submit */}
                </div>

              </div>
            </form>
          </div>
          {/* <div className="col-md-1"></div> */}

          <div className="col-md-4 contact-details" style={{}}>
            <div style={{ backgroundColor: "#262335aa", borderRadius: "12px", padding: "16px", }}>
              <h2 style={{ color: "#00ffd5", fontSize: "22px" }}>Contact Information</h2>

              <p className="address" style={{ color: "white" }}>
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Name</strong>  : Md Jahidul Islam <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Location</strong>  : Dhaka, Bangladesh <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Languages</strong>  : English, Bengali <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Full-time</strong>  : preferred <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Freelance</strong>  : Available <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Mobile</strong>  : +880 1938901990 <br />
                  </div>
                  <div>
                    <strong className="left-column"> <span>&bull;</span> Email</strong>  : za0162hid@gmail.com <br />
                  </div>
                </div>
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
